// extracted by mini-css-extract-plugin
export default {"form":"ReplyTicketForm_form__fsO+C"};